import { Tooltip } from '@mui/material';
import { Metric } from '@strength/domain';
import {
  SetMetricMutationData,
  WorkoutExercise,
} from '@strength/domain-workout';
import { WorkoutWithCycleAndSession } from '../../types';
import { resolveSlotWorkout } from '../cross-block-resolver';
import { WorkoutSummaryPrescriptionMutationFns } from '../types';
import { BaseWorkoutSlot } from './BaseWorkoutSlot';
import { DisabledSlot } from './common';
import { getRepsValueForMetricKeyword } from './workout-metric-utils';

interface PrescriptionSlotProps {
  x: number;
  y: number;
  workout: WorkoutWithCycleAndSession | undefined;
  metricKeyword: string;
  mutationFns: WorkoutSummaryPrescriptionMutationFns;
  getMetric: (metricId: string) => Metric;
  readOnly?: boolean;
}

export const PrescriptionSlot = ({
  x,
  y,
  metricKeyword,
  workout,
  mutationFns,
  getMetric,
  readOnly = false,
}: PrescriptionSlotProps) => {
  const resolved = workout
    ? resolveSlotWorkout(workout, workout.crossBlock)
    : undefined;
  const workoutForRender = resolved?.workout;
  const disabled = resolved?.isOverlay ?? false;

  const {
    value: repsValue,
    metric,
    workoutExercise,
    workoutSet,
  } = getRepsValueForMetricKeyword(metricKeyword, workoutForRender);

  if (
    repsValue !== undefined &&
    metric &&
    workoutExercise &&
    workoutSet &&
    workout
  ) {
    const onEditSetMetric = (
      workoutId: string,
      workoutSetId: string,
      data: SetMetricMutationData,
    ) => {
      mutationFns.onEditSetMetric(workoutId, workoutSetId, data);
    };

    const instruction = getInstructionIconForPrescriptionSlot(
      workoutExercise,
      metricKeyword,
    );

    return BaseWorkoutSlot(
      x,
      y,
      repsValue,
      metric,
      workoutExercise,
      workoutSet,
      onEditSetMetric,
      getMetric,
      !!readOnly || disabled,
      disabled, // disable context menu on cross-block overlay cells
      instruction,
    );
  } else {
    return DisabledSlot(x, y);
  }
};

// We only should show the instruction for the slot for the Modified metric keyword
const getInstructionIconForPrescriptionSlot = (
  workoutExercise: WorkoutExercise,
  metricKeyword: string,
) => {
  const instruction =
    metricKeyword === 'Modified'
      ? workoutExercise.instruction ?? undefined
      : undefined;

  return instruction ? (
    <Tooltip title={instruction} placement="bottom" arrow>
      <span
        className="block w-2 h-2 bg-yellow-500 shrink-0"
        aria-label={instruction}
      />
    </Tooltip>
  ) : undefined;
};
